import React from "react";
import { getRediretUrl } from "../utils/helpers";

function SuccessRegion({ product }) {
  const redirect = (e) => {
    e.preventDefault();
    window.location.href = getRediretUrl(product);
  };
  return (
    <div className="section section-center">
      <div className="success">
        <div className="spacer">&nbsp;</div>
        <div className="success-title">Account Created Successfully</div>
        <div className="success-msg">
          Thank you for your purchase. Your payment has been successfully
          processed.{" "}
          <b>
            An account activation email has been sent to your inbox. If you don’t see it, please check your spam or junk folder.
          </b>
        </div>
        <div className="success-msg">
          If you have any questions or need further assistance, please don't
          hesitate to contact our customer support.
        </div>
        <button
          id="btnSubmit"
          name="btnSubmit"
          className="btn-small hot active"
          onClick={redirect}
        >
          Sign in
        </button>
      </div>
    </div>
  );
}

export default SuccessRegion;
